import * as React from 'react';
import Icon from 'antd/lib/icon';
import uuid from 'uuid';
import Drawer from 'antd/lib/drawer';
import Button from 'antd/lib/button';
import Select from 'antd/lib/select';
import Form from 'antd/lib/form';
import message from 'antd/lib/message';
import Tooltip from 'antd/lib/tooltip';
import Modal from 'antd/lib/modal';
import StepOne from './new-shipment.first';
import StepTwo from './new-shipment.second';
import StepThree from './new-shipment.third';
import GenericHoc from 'src/components/hoc/GenericHoc';
import { OrgTypes, AccessType, EximModules, ModesOfService, StakeholderTypes, LocationType, LocationTypes } from 'src/Library/Constants';
import { newShipmentStyles } from './new-shipment.styles';
import { useGenericState } from 'src/Library/UseGenericState';
import { SHIP_EXEC_SHIPPER } from 'src/utils/partsToShow/partsConstants';
import { HocOptions, PermissionTypes } from 'src/components/hoc/GenericHoc.types';
import { initialState, ButtonNames, TabNames, TabDescription, ShipmentFormFields, formItemLayout, ProductFormFieldExtraKeys, ContainerFormFieldExtraKeys, ShipmentFormFieldsDomestic, ShipmentFormFieldsRPTL } from './new-shipment.constants';
import { NewShipmentProps, NewShipmentState, CurrentPage, ButtonAction, Product, Container, FormField, ShipmentApiBody } from './new-shipment.types';
import { searchBookingId, editShipment, createShipment, getBookingDetails, getNewShipmentFormConfig } from 'src/api/shipmentExecution';
import { useDebounce } from 'src/hooks/useDebounce';
import { NewShipmentHelper } from './new-shipment.helper';
import FormItem from 'antd/lib/form/FormItem';
import Spin from 'antd/lib/spin';
import { isValidArray } from 'src/Library/Helper';
import { MOVEMENT_TYPES } from '../../Container/ContainerUtils';
import { isValidDate } from 'src/utils/utils';
import moment from 'moment';
import { fetchInquiryDetailsForShipper } from 'src/api/inquiry';
import { getAddress } from 'src/api/organisationProfiling';
import { PREFILL_PLANT_ADDRESS_TYPE } from 'src/Library/MasterDataType';
import { PortTypes } from 'src/Library/Types';

let timeoutCall;

const NewShipment = (props: NewShipmentProps) => {
  const { classes, form, executionMaster, editData, disableBooking, handleClose, ctOrBooking, disableGrossWeightCalculation, showRoadinsteadOfDomestic, stakeholderAccountType, inquiryMaster, enableBookingDetach } = props;

  const [state, setState] = useGenericState<NewShipmentState>(initialState);
  const [bookingList, setBookingList] = React.useState<{id: string; bookingNumber: string }[]>([]);
  const [bookingId, setBookingId] = React.useState<any>();
  const [queryString, setQuery] = React.useState<string>('');
  const [fetching, setFetching] = React.useState<boolean>(true);
  const [loading, setLoading] = React.useState<boolean>(true);
  const [creating, setCreating] = React.useState<boolean>(false);
  const [formContent, setFormData] = React.useState<any>(editData);
  const [productsList, setProducts] = React.useState<Product[]>();
  const [containerList, setContainers] = React.useState<Container[]>();
  const [customerDetails, setCustomerDetails] = React.useState<any>([]);
  const [stakeholderDetails, setStakeholderDetails] = React.useState<any>([]);
  const [originAddressDetails, setOriginAddressDetails] = React.useState<any>([]);
  const [destinationAddressDetails, setDestinationAddressDetails] = React.useState<any>([]);
  const [teamIds, setTeamsDetails] = React.useState<any>([]);
  const [formFieldConfig, setFormFieldConfig] = React.useState({});
  const [isConfigLoading, setIsConfigLoading] = React.useState<boolean>(false);
  const [isPrefillLoading, setIsPrefillLoading] = React.useState<boolean>(false);
  const [pageErrorMap, setPageErrorMap] = React.useState({});
  // const [isBlNumberPresent, setIsBlNumberPresent] = React.useState(false);
  const [customFieldsMap, setCustomFieldsMap] = React.useState([] as {
    dbKey: string;
    type: string;
  }[]);
  const [showPlantConfirmModal, setShowPlantConfirmModal] = React.useState(false);
  const [pendingApiBody, setPendingApiBody] = React.useState<ShipmentApiBody | null>(null);
  const [selectedPlantDisplay, setSelectedPlantDisplay] = React.useState<string>('');
  const isSubmitInProgressRef = React.useRef(false);
  // Set once the user clears or swaps a linked booking. Tracked explicitly rather than inferred from
  // the field, because the prefill effect rewrites that field and would otherwise erase the intent.
  const [bookingLinkEdited, setBookingLinkEdited] = React.useState<boolean>(false);
  const [detaching, setDetaching] = React.useState<boolean>(false);

  const { currentPage } = state;
  const { getFieldDecorator } = form;
  const searchDebounce = useDebounce(queryString);

  const {
    BLNUMBER,
    TRANSPORTER,
    CFS,
    ICD,
    BREAK_BULK,
    SURVEYOR,
    INTER_CARTING,
    BOOKINGNUMBER,
    LOADINGLOCATION,
    UNLOADINGLOCATION,
    MODE,
    INCOTERM,
    MOVEMENT,
    CONTAINER_HEIGHT,
    CONTAINER_BREADTH,
    CONTAINER_LENGTH,
    CONTAINER,
    PRODUCT,
    UNLOADING,
    LOADING,
    DESTINATION_ADDRESS,
    ORIGIN_ADDRESS,
    PICKUP,
    ORIGIN_PORT, 
    DESTINATION_PORT,
    ORIGIN_COUNTRY,
    DESTINATION_COUNTRY,
    ORIGIN_SERVICE,
    DESTINATION_SERVICE,
    CARRIER
  } = ShipmentFormFields;

  React.useEffect(() => {
    updateFormData();
  }, [])

  React.useEffect(() => {
    const mode = form.getFieldValue(MODE.key);
    if (mode) {
      const resetFieldsList = [
        ORIGIN_SERVICE.key,
        DESTINATION_SERVICE.key,
        ORIGIN_PORT.key,
        DESTINATION_PORT.key,
        CARRIER.key
      ];
      if (mode !== ModesOfService.DOMESTIC) {
        resetFieldsList.push(ORIGIN_COUNTRY.key);
        resetFieldsList.push(DESTINATION_COUNTRY.key);
      }
      // Only clear mode-incompatible fields on a genuine user-driven mode change.
      // During a booking-based prefill (bookingId set) OR an edit (editData.id set),
      // setFieldsValue sets MODE and the ports/countries/carrier together; letting this
      // run would wipe the just-prefilled values (mode is disabled in that state anyway).
      if (!editData?.id && !bookingId) {
        const fieldsData = form.getFieldsValue();
        const validResetFieldsList = resetFieldsList.reduce((a, v) => {
          if (fieldsData[v]) {
            return {...a, [v]: undefined};
          } else {
            return a
          }
        }, {});
        form.setFieldsValue(validResetFieldsList);
      }
    }
  }, [form.getFieldValue(MODE.key)]);

  const fetchNewShipmentFormConfig = async () => {
    setIsConfigLoading(true);
    const mode = form.getFieldValue(MODE.key);
    const type = form.getFieldValue(MOVEMENT.key);
    const incoterm = form.getFieldValue(INCOTERM.key);

    const isCustomer = stakeholderAccountType === StakeholderTypes.CUSTOMER;
    const shipperId = isCustomer ? form.getFieldValue('shipperId') : undefined;

    const body = {
      moduleCode: 'SHIPMENT_EXECUTION',
      userFormCode: 'CREATE_EXECUTION',
      params: {
        mode,
        type,
        incoterm
      },
      ctShipmentId: formContent?.ctShipmentId,
      ...(isCustomer && { shipperId }),
    }
    const response = await getNewShipmentFormConfig(body);
    if (response.isSuccess) {
      const data = response.data.reduce((acc, curr) => {
        acc[curr.fieldCode] = curr?.isMandatory || false;
        return acc;
      }, {});
      setFormFieldConfig(data);
      const fieldValues = form.getFieldsValue();
      const resetFields = Object.keys(fieldValues).reduce((prev, curr) => {
        if (!fieldValues[curr]) {
          return [...prev, curr];
        }
        return prev;
      }, []);
      form.resetFields(resetFields);
    }
    setTimeout(() => {
      isBlNumberPresent = isBlPresent();
      setState({
        ...state,
        visited: {
          FIRST: true,
          SECOND: false,
          THIRD: false,
        }
      });
      setPageErrorMap({});
      setIsConfigLoading(false);
    }, 1000);
  }

  React.useEffect(() => {
    if (timeoutCall) {
      clearTimeout(timeoutCall);
    }
    if (form.getFieldValue(MODE.key) && form.getFieldValue(MOVEMENT.key) && !isConfigLoading) {
      timeoutCall = setTimeout(() => {
        fetchNewShipmentFormConfig();
      }, 500)
    } else {
      setIsConfigLoading(false)
    }

    if (form.getFieldValue(BLNUMBER.key)) {
      isBlNumberPresent = isBlPresent();
    }

  }, [form.getFieldValue(MODE.key), form.getFieldValue(MOVEMENT.key), form.getFieldValue(INCOTERM.key), form.getFieldValue(BLNUMBER.key)]);
  
  const isBlPresent = () => {
    return Boolean(
      (form.getFieldValue(BLNUMBER.key) || editData?.blNumber)
      && form.getFieldValue(MODE.key) === ModesOfService.FCL
      && form.getFieldValue(MOVEMENT.key) === MOVEMENT_TYPES.IMPORT
    );
    // if (currentPage === CurrentPage.FIRST) {
    //   return Boolean(form.getFieldValue(BLNUMBER.key));
    // }
    // return Boolean(formContent.blNumber);
  }

  let isBlNumberPresent = isBlPresent();


  const updateFormData = () => {
    const formValues = form.getFieldsValue();
    const updatedData = {
      ...formContent,
      ...formValues,
    };
    setFormData(updatedData);

    const newContainerList: Container[] = [];
    const newProductList: Product[] = [];

    Object.keys(updatedData?.packagingDetails || {}).forEach(
      (id) => {
        if (!id.length) return;
        newContainerList.push({
          id,
          ...updatedData?.packagingDetails[id],
        });
      }
    );
    newContainerList.length === 0 && newContainerList.push({ id: uuid() });
    setContainers(newContainerList);
    
    Object.keys(updatedData?.productDetails || {}).map(
      (id) => {
        if (!id.length) return;
        const productDetail = updatedData?.productDetails[id];
        const productKey = productDetail?.key;
        
        // Handle both object format {key, label} and primitive ID format
        let keyValue: string | undefined;
        let internalNameValue: string | undefined;
        
        if (productKey && typeof productKey === 'object' && productKey !== null) {
          // If key is an object with key and label properties
          keyValue = productKey?.key;
          internalNameValue = productKey?.label;
        }
        
        newProductList.push({
          id,
          ...productDetail,
          key: keyValue,
          internalName: internalNameValue,
        });
      }
    )
    newProductList.length === 0 && newProductList.push({ id: uuid() });
    setProducts(newProductList);
  };

  const handleSearch = async () => {
    setFetching(true);
    try {
      const result = await searchBookingId({ queryString });
      setBookingList(result?.data || []);
    } catch (error) {
      message.error('Failed to search booking');
    } finally {
      setFetching(false);
    }
  };

  React.useEffect(() => {
    handleSearch();
  }, [searchDebounce]);

  const handlePageChange = (action: ButtonAction) => {
    let nextPage = currentPage;
    // updateFormData();
    if (currentPage !== CurrentPage.SECOND) {
      nextPage = CurrentPage.SECOND;
    } else if (action === ButtonAction.NEXT) {
      nextPage = CurrentPage.THIRD;
    } else {
      nextPage = CurrentPage.FIRST;
    }
    setState({ currentPage: nextPage });
  }

  const getProductList = (formData) => {
    const products: Product[] = [];
    Object.keys(formData?.productDetails || {}).forEach((item) => {
      if (formData?.productDetails[item]?.key?.key) {
        products.push({
          ...formData?.productDetails[item],
          key: (formData?.productDetails[item]?.key?.key.toString()),
        });
      }
    });

    return products;
  };

  const getCustomFieldsArr = (formData) => {
    if (isValidArray(formData.customFields)) {
      return formData?.customFields;
    }

    const customFieldsValues = formData.customFields || {};
    return Object.keys(customFieldsValues || {})?.map((dbKey) => {
      const customFieldPayload = {
        dbKey,
        value: customFieldsValues[dbKey]
      }
      const fieldMap = customFieldsMap?.filter(fieldObj => fieldObj?.dbKey === dbKey)?.[0];
      const fieldType = fieldMap?.type?.toLowerCase();
      if (fieldType === 'date' && isValidDate(customFieldsValues[dbKey])) {
        customFieldPayload.value = moment((customFieldsValues[dbKey]))?.format('YYYY-MM-DD');
      }
      return customFieldPayload;
    })?.filter(item => (item.value));
  };

  const LCLRPTLNonMandatoryKey = (formData, key: string) => {
    const isMandatoryInConfig = formFieldConfig[CONTAINER_BREADTH?.configKey] || formFieldConfig[CONTAINER_LENGTH?.configKey] || formFieldConfig[CONTAINER_HEIGHT?.configKey]
    return (formData.mode === ModesOfService.LCL || formData.mode === ModesOfService.RPTL || formData.mode === ModesOfService.BREAK_BULK) && (key === 'breadth' || key === 'length' || key === 'height') && !isMandatoryInConfig;
  }

  const OutOfGaugeNonMandatoryKey = (packageDetails, key: string) => {
    return ['OPEN_TOP','FLAT_RACK'].includes(packageDetails.type) && !packageDetails.outOfGauge && (key === 'breadth' || key === 'length' || key === 'height');
  }

  const checkDefaultAndFormConfig = (key, map) => {
    const checkKey = Object.keys(map).filter(cKey => map[cKey].key === key)?.[0];
    if (checkKey) {
      return formFieldConfig[map[checkKey]?.configKey] ?? map[checkKey]?.required
    } return false;
  }

  const getContainerNumbers = (formData) => {
    const containers: Container[] = [];
    const nonRequiredFields: string[] = ['totalWeight', 'totalWeightUnit', 'outOfGauge'];
    Object.keys(formData?.packagingDetails || {}).forEach((item) => {
      const packageObject = formData.packagingDetails[item];
      const missing = Object.keys(packageObject || {}).some(key => {
        /** for mode LCL L, B, H are non-mandatory */
        if (LCLRPTLNonMandatoryKey(formData, key)) {
          return false;
        }
        if (OutOfGaugeNonMandatoryKey(packageObject, key)) {
          return false
        }
        if (nonRequiredFields.findIndex(item => item === key) >= 0)
          return false;
        const isMandatory = checkDefaultAndFormConfig(key, ContainerFormFieldExtraKeys);
        const isError = (!packageObject[key] && packageObject[key] !== 0);
        return isMandatory && isError;
      });
      if (!missing || isBlNumberPresent) {
        let formValues = Object.assign({}, formData.packagingDetails[item]);
        if (formData?.mode === ModesOfService.LCL || formData?.mode === ModesOfService.RPTL || formData?.mode === ModesOfService.BREAK_BULK) {
          formValues = Object.assign({
            grossWeight: formData.packagingDetails[item]?.totalWeight,
            grossWeightUnit: formData.packagingDetails[item]?.totalWeightUnit,
          }, formData.packagingDetails[item]);
        }

        if (formValues?.outOfGauge === false) {
          delete formValues.length;
          delete formValues.height;
          delete formValues.breadth;
          delete formValues.dimensionUnit;
        }

        // delete formValues?.outOfGauge;

        /** Removed containerObject with all values undefined */
        const emptyFormValues = Object.keys(formValues).filter(key => !formValues[key]).length;
        if (emptyFormValues === Object.keys(formValues).length) {
          return;
        }
        
        containers.push(formValues);
      }
    });
    return containers;
  };

  function getRequiredKeys(formData, apiBody) {
    const requiredKeys: string[] = [];
    let err = false;
    if (form.getFieldValue('blNumber')) {
      return {
        requiredKeys: [],
        extraKeys: [],
      }
    }
    const mode = form.getFieldValue(MODE.key);
    const formFields = mode === ModesOfService.DOMESTIC ? ShipmentFormFieldsDomestic : mode === ModesOfService.RPTL ? ShipmentFormFieldsRPTL : ShipmentFormFields;

    Object.keys(formFields || {}).forEach((item) => {
      if (item === 'TEAM') {
        if (apiBody.accessType === AccessType.TEAMS) {
          requiredKeys.push(formFields[item].key);
        }
      } else if ((formFieldConfig[formFields[item].configKey] ?? formFields[item].required)) {
        if (['UNLOADINGLOCATION', 'LOADINGLOCATION', 'ORIGIN_ADDRESS', 'DESTINATION_ADDRESS'].includes(item)) {
          if (item === 'UNLOADINGLOCATION' && apiBody[UNLOADING.key] === 'Factory') {
            requiredKeys.push(formFields[item].key);
          } else if (item === 'LOADINGLOCATION' && apiBody[LOADING.key] === 'Factory') { 
            requiredKeys.push(formFields[item].key);
          } else if (item === 'ORIGIN_ADDRESS' && apiBody[PICKUP.key]?.startsWith('Door')) {
            requiredKeys.push(formFields[item].key);
          } else if (item === 'DESTINATION_ADDRESS' && apiBody[PICKUP.key]?.endsWith('Door')) {
            requiredKeys.push(formFields[item].key);
          }
        } else if (item === 'POL') { 
            if (apiBody.originPortType === 'DRY') {
              requiredKeys.push(formFields[item].key);
            }
        } else if (item === 'POD') {
            if (apiBody.destinationPortType === 'DRY') {
              requiredKeys.push(formFields[item].key);
            }
        } else if (item === 'STACKABLE') {
            if (apiBody[MODE.key] && apiBody[MODE.key] !== ModesOfService.FCL) {
              requiredKeys.push(formFields[item].key);
            }
        } else if (item === 'SUPPLIER') {
            if (apiBody[MOVEMENT.key] === MOVEMENT_TYPES.IMPORT) {
              requiredKeys.push(formFields.CUSTOMER.key);
            }
        } else if (item === 'CUSTOMER') {
            if (apiBody[MOVEMENT.key] !== MOVEMENT_TYPES.IMPORT) {
              requiredKeys.push(formFields.CUSTOMER.key);
            }
        } else if (item === 'BLNUMBER') { 
          if (apiBody[MODE.key] === ModesOfService.FCL && apiBody[MOVEMENT.key] === MOVEMENT_TYPES.IMPORT) {
            requiredKeys.push(formFields[item].key);
          }
        } else {
          requiredKeys.push(formFields[item].key);
        }
      }
    });

    const extraKeys: string [] = [];
    const nonRequiredFields: string[] = [];

    if (!formFieldConfig[ContainerFormFieldExtraKeys.CONTAINER_TOTAL_WEIGHT.configKey]) {
      nonRequiredFields.push('totalWeight');
    } 
    if (!formFieldConfig[ContainerFormFieldExtraKeys.CONTAINER_TOTAL_WEIGHT_UNIT.configKey]) {
      nonRequiredFields.push('totalWeightUnit');
    }

    if (!disableBooking) {
      Object.keys(formData.packagingDetails || {}).forEach((key, idx) => {
        Object.keys(formData.packagingDetails[key] || {}).forEach(item => {
          if ((formFieldConfig[Object.values(ContainerFormFieldExtraKeys).filter(data => data.key === item)?.[0]?.configKey] ?? item) && nonRequiredFields.findIndex(val => item === val) < 0) {
            extraKeys.push(`${formFields.CONTAINER.key}[${key}]['${item}']`);
          }
        });
      });

      Object.keys(formData.productDetails || {}).forEach((key, idx) => {
        Object.keys(formData.productDetails[key] || {}).forEach(item => {
          if (formFieldConfig[Object.values(ProductFormFieldExtraKeys).filter(data => data.key === item)?.[0]?.configKey]) {
            extraKeys.push(`${formFields.PRODUCT.key}[${key}]['${item}']`);
          }
        });
      });
    }
    return {
      requiredKeys,
      extraKeys,
    };
  }

  const getTeamIds = (formData) => {
    if (!formData?.teamIds?.length) {
      return [];
    }
    
    return formData.teamIds.map(team => team.key);
  }

  const getLocation = (formData, key) => {
    if (
      // formData?.type === MOVEMENT_TYPES.EXPORT &&
      // formData?.originLocationType === 'Factory' &&
      key === LOADINGLOCATION.key
    ) {
      return formData?.[LOADINGLOCATION.key]?.key;
    }
    if (
      // formData?.type === MOVEMENT_TYPES.IMPORT &&
      // formData?.destinationLocationType === 'Factory' &&
      key === UNLOADINGLOCATION.key
    ) {
      return formData?.[UNLOADINGLOCATION.key]?.key;
    }
    return undefined;
  }

  function getKeysList(selectedList){
    if ( Array.isArray(selectedList) ){
      return selectedList.map(item => item?.key) // should we provide something else if key not present for any entry
    }
    return [];
  }

  function getApiBody() {
    const mode = form.getFieldValue(MODE.key);
    const newData = form.getFieldsValue();
    const formData = {
      ...formContent,
      ...newData,
    };

    const isCustomer = stakeholderAccountType === StakeholderTypes.CUSTOMER;

    // merge product details with product list
    (formData?.productList || []).forEach( (product) => {
      formData.productDetails[product?.id] = {
        ...product,
        ...formData.productDetails[product?.id]
      }
    })
    
    const supplierId = (formData.type === 'IMPORT' || formData.type === 'TRADE') && formData.supplierIds?.length 
        ? getKeysList(formData.supplierIds)?.[0] 
        : undefined;

    const apiBody = {
      id: editData?.id,
      mode: formData?.mode,
      originAddress: formData?.originAddress,
      destinationAddress: formData?.destinationAddress,
      incoterm: (mode === ModesOfService.DOMESTIC || mode === ModesOfService.RPTL) ? 'DAT' : formData?.incoterm,
      type: (mode === ModesOfService.DOMESTIC) ? 'TRADE' : formData.type,
      cargoType: formData?.cargoType,
      cargoSubtype: formData?.cargoSubtype,
      originServices: formData?.originServices,
      destinationServices: formData?.destinationServices,
      pickupAndDrop: formData?.pickupAndDrop,
      originLocationType: formData?.originLocationType,
      [LOADINGLOCATION.key]: (mode === ModesOfService.DOMESTIC || mode === ModesOfService.RPTL)
        ? (editData?.id 
          ? editData?.originLocationId || editData?.originLocationDetails?.id 
          : formData?.originLocationId?.key
        )
        : getLocation(formData, LOADINGLOCATION.key),
      destinationLocationType: formData?.destinationLocationType,
      [UNLOADINGLOCATION.key]: (mode === ModesOfService.DOMESTIC || mode === ModesOfService.RPTL)
        ? (editData?.id 
            ? editData?.destinationLocationId || editData?.destinationLocationDetails?.id 
            : formData?.destinationLocationId?.key
        )
        : getLocation(formData, UNLOADINGLOCATION.key),
      customFields: getCustomFieldsArr(formData),
      teamIds: getTeamIds(formData),
      ffId: formData.ffId?.key,
      chaId: formData.chaId?.key,
      parentId: formData.parentId?.key,
      childId: formData.childId?.key,
      [TRANSPORTER.key]: formData[TRANSPORTER.key]?.key,
      [CFS.key]: formData[CFS.key]?.key,
      [ICD.key]: formData[ICD.key]?.key,
      [BREAK_BULK.key]: formData[BREAK_BULK.key]?.key,
      [SURVEYOR.key]: formData[SURVEYOR.key]?.key,
      [INTER_CARTING.key]: formData[INTER_CARTING.key]?.key,
      ...(isCustomer ? { shipperId: formData.shipperId?.key ?? formData.shipperId } : {}),
      customerIds: (formData.type === 'EXPORT' || formData.type === 'TRADE')? getKeysList(formData.customerIds) : [],
      customerId: isCustomer ? executionMaster.organisationId : undefined,
      supplierId: supplierId ?? formData.supplierId?.key,
      supplierIds: (formData.type === 'IMPORT' || formData.type === 'TRADE')? getKeysList(formData.supplierIds) : [],
      accessType: formData.accessType?.key,
      carrierCode: (mode === ModesOfService.DOMESTIC || mode === ModesOfService.RPTL) ? null : formData.carrierCode,
      // origin port details
      originPortCode: formData.originPortCode?.key,
      originPortType: formData.originPortCode?.type,
      originPolCode: formData.originPortCode?.type === PortTypes.DRY ? formData?.originPolCode?.key : undefined,
      // destination port details
      destinationPortCode: formData.destinationPortCode?.key,
      destinationPortType: formData.destinationPortCode?.type,
      destinationPodCode: formData.destinationPortCode?.type === PortTypes.DRY ? formData?.destinationPodCode?.key : undefined,

      productDetails: getProductList(formData),
      packagingDetails: getContainerNumbers(formData), // Container details
      originCountryCode: (mode === ModesOfService.DOMESTIC || mode === ModesOfService.RPTL)
        ? (editData?.id 
            ? editData?.originLocationDetails?.countryCode || editData?.originLocationDetails?.country_code 
            : formData?.originCountryCode?.key
        )
        : formData.originCountryCode?.key,
      destinationCountryCode: (mode === ModesOfService.DOMESTIC || mode === ModesOfService.RPTL)
        ? (editData?.id 
            ? editData?.destinationLocationDetails?.countryCode || editData?.destinationLocationDetails?.country_code 
            : formData?.destinationCountryCode?.key
        )
        : formData.destinationCountryCode?.key,
      termsAndConditions: formData?.termsAndConditions,
      containerNumber: formData?.containerNumber,
      bookingNumber: formData?.bookingNumber,
      blNumber: editData?.blNumber ?? formData?.blNumber,
      salesOrderNumber: formData?.salesOrderNumber,
      clientReferenceNumber: formData?.clientReferenceNumber,
      invoiceNumberList: formData?.invoiceNumberList,
      purchaseOrderNumberList: formData?.purchaseOrderNumberList,
      ctShipmentId: formData?.ctShipmentId,
      documents: formData?.documents,
      plantId: formData.plantId?.key,
      // When the linked booking was cleared or swapped in this session the source follows the field,
      // not the value prefilled from the shipment - otherwise clearing would silently re-link the old
      // booking and a swap would keep pointing at it. `null` is what tells the backend to unlink.
      sourceObjectId: bookingLinkEdited ? (bookingId || null) : (formData?.sourceObjectId || bookingId),
      sourceObjectType: bookingLinkEdited
        ? (bookingId ? 'BOOKING' : null)
        : (formData?.sourceObjectType || bookingId ? 'BOOKING' : undefined),
      watcherList: formData?.watcherList,
      isCargoStackable: formData.mode !== ModesOfService.FCL ? formData?.stackable : undefined
    };

    const nonRequiredFields: string[] = [];
    if (!formFieldConfig[ContainerFormFieldExtraKeys.CONTAINER_TOTAL_WEIGHT.configKey]) {
      nonRequiredFields.push('totalWeight');
    } 
    if (!formFieldConfig[ContainerFormFieldExtraKeys.CONTAINER_TOTAL_WEIGHT_UNIT.configKey]) {
      nonRequiredFields.push('totalWeightUnit');
    }
    const packagingErr = formFieldConfig[ContainerFormFieldExtraKeys.CONTAINER_TYPE.configKey] ?
      (!apiBody.packagingDetails?.length ||
      apiBody.packagingDetails?.some((item: Container) => {
        return Object.keys(item).some(key => {
          if (LCLRPTLNonMandatoryKey(formData, key)) return false;
          if (nonRequiredFields.findIndex(item => item === key) >= 0) return false;
          return (!item[key] && item[key] !== 0);
        });
      })) : false;

    // Matches the edit dispatch in handleSubmit (apiBody.id && !disableBooking):
    // only a real edit hits PUT /execution/:id, so only then do cleared
    // stakeholders need to be sent as null. ISS-291273
    const isEdit = Boolean(editData?.id) && !disableBooking;
    Object.keys(apiBody).forEach(key => {
      if (key === 'isCargoStackable' && formData.mode !== ModesOfService.FCL) {
        return;
      }
      if (!apiBody[key]) {
        // Cleared optional fields (stakeholders + reference fields) must go out as
        // an explicit null on edit so the backend clears them; otherwise undefined
        // is stripped by JSON.stringify and the old value is retained. Road-mode
        // Transporter is excluded inside the helper (aliases ff_id). ISS-291273
        apiBody[key] = NewShipmentHelper.resolveEmptyFieldValue(key, isEdit, mode);
      }
    });

    const { requiredKeys, extraKeys } = getRequiredKeys(formData, apiBody);
    const errorKeys = {};
    requiredKeys.forEach(key => {
      let isError = !(apiBody[key] && (Array.isArray(apiBody[key]) ? apiBody[key]?.length : apiBody[key] !== 0));
      if (key === 'stackable') {
        isError = apiBody.isCargoStackable === undefined;
      }
      if (isError) {
        errorKeys[key] = {error: 'required'}
      }
      return isError;
    });
    checkFieldErrors(errorKeys);
    return {
      apiBody,
      err: !isBlNumberPresent ? (packagingErr || Object.keys(errorKeys)?.length): false,
      requiredKeys: [...requiredKeys, ...extraKeys],
    };
  }

  const getApiBodyAndUpdate = () => {
    updateFormData();
    return getApiBody();
  }

  const prefillBookingOrShipment = async () => {
    let response;
    let dataToPrefill;
    setIsPrefillLoading(true);
    try {
      if (ctOrBooking === EximModules.BOOKING || bookingId) {
        response = await getBookingDetails(bookingId || editData?.id);
        const inquiryResponse = await fetchInquiryDetailsForShipper({
          inquiryId: response?.data?.id
        });
        dataToPrefill = {
          ...editData,
          ...(inquiryResponse?.data || {}),
          ...(response?.data || {}),
        }
        // ISS-289339: when linking a booking to an existing shipment, the booking's
        // access fields must not override the shipment's existing access team.
        // accessorType / teamId are read by getAccessInitial / getTeamIds as optional
        // raw fields but are not declared on ExecutionShipment, so narrow-cast just
        // those two; the rest are typed.
        if (editData?.id) {
          dataToPrefill.accessType = editData.accessType;
          dataToPrefill.accessorType = (editData as { accessorType?: string }).accessorType;
          dataToPrefill.teamId = (editData as { teamId?: string }).teamId;
          dataToPrefill.teamName = editData.teamName;
          dataToPrefill.teamList = editData.teamList;
          dataToPrefill.teamDetails = editData.teamDetails;
        }
      } else {
        dataToPrefill = editData;
      }
      // Extract location data BEFORE conversion (they get lost after convertEditdata)
      // Use originLocationId/destinationLocationId if available, otherwise use stuffing address
      const rawOriginLocationId = dataToPrefill?.originLocationId;
      const rawOriginStuffingAddress = dataToPrefill?.origin?.stuffingDestuffingAddress;
      const rawOriginStuffingAddressId = dataToPrefill?.origin?.stuffingDestuffingAddressId;
      const rawOriginLocationType = dataToPrefill?.origin?.locationType || dataToPrefill?.originLocationDetails?.locationType || dataToPrefill?.originLocationType;
      const rawDestinationLocationId = dataToPrefill?.destinationLocationId;
      const rawDestinationStuffingAddress = dataToPrefill?.destination?.stuffingDestuffingAddress;
      const rawDestinationStuffingAddressId = dataToPrefill?.destination?.stuffingDestuffingAddressId;
      const rawDestinationLocationType = dataToPrefill?.destination?.locationType || dataToPrefill?.destinationLocationDetails?.locationType || dataToPrefill?.destinationLocationType;
      const rawShipperId = dataToPrefill?.shipperId;
      dataToPrefill = NewShipmentHelper.convertEditdata(dataToPrefill, disableBooking);
      if (dataToPrefill?.containerList?.length) {
        dataToPrefill.packagingDetails = dataToPrefill.containerList?.reduce((prev, curr) => {
          const {id, ...restValue} = curr;
          return {...prev, [curr.id]: restValue}
        }, {});
      }

      // Prefill plant based on stuffing/destuffing address if plantId is not already set
      // Only prefill if prefill_plant_with_destination_or_origin_address is defined
      if (!dataToPrefill?.plantId && executionMaster.prefill_plant_with_destination_or_origin_address !== undefined) {
        try {
          // Helper function to determine target address details
          const getTargetAddressDetails = (locationId, stuffingAddressId, stuffingAddress) => {
            let targetAddress;
            let targetAddressId;
            let isStuffingAddress = false;

            // Priority 1: Use locationId if it matches stuffingDestuffingAddressId
            if (locationId && locationId === stuffingAddressId) {
              targetAddress = stuffingAddress;
              targetAddressId = locationId;
              isStuffingAddress = true;
            }
            // Priority 2: Use stuffingDestuffingAddressId even if it doesn't match locationId
            else if (stuffingAddressId) {
              targetAddress = stuffingAddress;
              targetAddressId = stuffingAddressId;
              isStuffingAddress = true;
            }
            // Priority 3: Use locationId as fallback (need to check location type)
            else if (locationId) {
              targetAddressId = locationId;
            }

            return { targetAddress, targetAddressId, isStuffingAddress };
          };

          // Determine which stuffing/destuffing address to use based on config
          let targetAddress;
          let targetAddressId;
          let targetLocationType;
          let isStuffingAddress = false;
          
          if (executionMaster.prefill_plant_with_destination_or_origin_address === PREFILL_PLANT_ADDRESS_TYPE.DESTINATION) {
            targetLocationType = rawDestinationLocationType;
            const details = getTargetAddressDetails(rawDestinationLocationId, rawDestinationStuffingAddressId, rawDestinationStuffingAddress);
            targetAddress = details.targetAddress;
            targetAddressId = details.targetAddressId;
            isStuffingAddress = details.isStuffingAddress;
          } else if (executionMaster.prefill_plant_with_destination_or_origin_address === PREFILL_PLANT_ADDRESS_TYPE.ORIGIN) {
            targetLocationType = rawOriginLocationType;
            const details = getTargetAddressDetails(rawOriginLocationId, rawOriginStuffingAddressId, rawOriginStuffingAddress);
            targetAddress = details.targetAddress;
            targetAddressId = details.targetAddressId;
            isStuffingAddress = details.isStuffingAddress;
          }

          // Prefill logic:
          // - If the address id is present, fetch the address details and check if the location type is 'PLANT'
          if (targetAddressId){
            const organisationId = window.localStorage.getItem('organisationId');
            const stakeholderIdForAddress =
              rawShipperId != null && organisationId !== String(rawShipperId)
                ? String(rawShipperId)
                : undefined;
            const addressRes = await getAddress(targetAddressId, stakeholderIdForAddress);
            if (addressRes.isSuccess){
              const consignorLocationType = addressRes.data?.locationType;
              const isPlant = consignorLocationType && (consignorLocationType.toUpperCase() === LocationTypes.PLANT);
              if (isPlant && targetLocationType.toUpperCase() === LocationTypes.FACTORY) {
                // Extract plant name from the address string if available
                let plantLabel = targetAddress || String(targetAddressId);
                if (targetAddress && targetAddress.includes(',')) {
                  plantLabel = targetAddress.split(',')[0].trim();
                }
                
                dataToPrefill.plantId = {
                  key: targetAddressId,
                  label: plantLabel
                };
              }
            }
          }
        } catch (error) {
          // Continue without prefilling plant if there's an error
        }
      }

      // Set productDetails in the correct format for form fields
      if (dataToPrefill?.productList?.length) {
        dataToPrefill.productDetails = dataToPrefill.productList?.reduce((prev, product) => {
          return {
            ...prev,
            [product.id]: {
              key: product?.key && product?.internalName ? {
                key: product.key,
                label: product.internalName,
              } : undefined,
              quantity: product?.quantity,
              unit: product?.unit,
              cases: product?.cases,
              skuClientNumber: product?.skuClientNumber,
            }
          };
        }, {});
      }

      // Deterministic fallback for Step-2 address textareas: when origin/destination address
      // is empty, use stuffing/destuffing address so setFieldsValue reliably prefills the fields.
      // Avoids intermittent blank textareas due to initialValue-one-time registration and async timing.
      dataToPrefill.originAddress = dataToPrefill.originAddress?.trim?.() || dataToPrefill.originStuffingAddress;
      dataToPrefill.destinationAddress = dataToPrefill.destinationAddress?.trim?.() || dataToPrefill.destinationStuffingAddress;


      setFormData(dataToPrefill);
      setProducts(dataToPrefill?.productList?.length ? dataToPrefill?.productList : [{ id: uuid() }]);
      setContainers(dataToPrefill?.containerList?.length ? dataToPrefill?.containerList : [{ id: uuid() }]);
      setCustomerDetails(dataToPrefill?.customer ? dataToPrefill?.customer : [{ id: uuid() }]);
      setStakeholderDetails(dataToPrefill?.stakeholder ? dataToPrefill?.stakeholder : [{ id: uuid() }]);
      setOriginAddressDetails(dataToPrefill?.originStuffingAddress ? dataToPrefill?.originStuffingAddress : [{ id: uuid() }]);
      setDestinationAddressDetails(dataToPrefill?.destinationStuffingAddress ? dataToPrefill?.destinationStuffingAddress : [{ id: uuid() }]);
      setTeamsDetails(dataToPrefill?.teamIds ? dataToPrefill?.teamIds : [{ id: uuid() }]);
      setTimeout(() => {
        try {
          if (bookingLinkEdited && !bookingId) {
            // The booking was cleared on purpose - do not let the shipment's own prefill put it back.
            delete dataToPrefill.bookingNumber;
          }
          form.setFieldsValue(dataToPrefill);
        } finally {
          setIsPrefillLoading(false);
        }
      }, 1000);
    } catch (error) {
      message.error('Failed to prefill booking/shipment data');
      setIsPrefillLoading(false);
    }
  }

  React.useEffect(() => {
    if (bookingId || editData?.id) {
        prefillBookingOrShipment();
    }
  }, [bookingId, editData?.id]);

  React.useEffect(() => {
    setState({
      visited: {
        ...state.visited,
        [state.currentPage]: true,
      },
    });
    getApiBody();
  }, [state.currentPage]);

  const checkFieldErrors = (error?: any, isSubmit = false) => {
    const mode = form.getFieldValue(MODE.key);
    const fields = mode === ModesOfService.DOMESTIC ? ShipmentFormFieldsDomestic : mode === ModesOfService.RPTL ? ShipmentFormFieldsRPTL : ShipmentFormFields;
    const pageErrorCount = {};

    const errors = error || {};
    const errorKeys = Object.keys(errors);
    errorKeys.forEach((key) => {
      if (key) {
        const val = Object.values(fields).filter((data) => data.key === key)?.[0];
        if (val?.step && (isSubmit || state.visited[val?.step])) {
          pageErrorCount[val?.step] = (pageErrorCount[val?.step] ?? 0) + 1;
        }
      }
    });
    setPageErrorMap(pageErrorCount);
    return pageErrorCount;
  }

  const checkForErrors = (isSubmit = false) => {
    const { apiBody, err, requiredKeys } = getApiBodyAndUpdate();
    
    // Validate that origin and destination locations are not the same
    const mode = form.getFieldValue(MODE.key);
    const isLocationBased = mode === ModesOfService.DOMESTIC || mode === ModesOfService.RPTL;
    const originLocation = apiBody[LOADINGLOCATION?.key];
    const destinationLocation = apiBody[UNLOADINGLOCATION.key];
    if (!inquiryMaster?.allowSamePolPod && isLocationBased && originLocation && destinationLocation && originLocation === destinationLocation) {
      message.error('Origin and destination location cannot be same');
      if (isSubmit) {
        handleTabChange(CurrentPage.FIRST);
      }
      return;
    }
    
    form.validateFieldsAndScroll(requiredKeys, (error, val) => {
      if (err || error) {
        message.error('Please fill all required fields');
        const pageErrorCount = checkFieldErrors(error, isSubmit);
        if (isSubmit) {
          Object.keys(pageErrorCount).some(pageKey => {
            if (pageErrorCount[pageKey]) {
              handleTabChange(pageKey);
              return true;
            };
            return false;
          }); 
        }
        return;
      }
      if (isSubmit) {
        // Guard: prevent double execution (e.g. validateFieldsAndScroll calling callback twice)
        if (isSubmitInProgressRef.current) {
          return;
        }
        isSubmitInProgressRef.current = true;

        // Show confirmation modal only if plant field has a value and config is enabled
        const plantFieldValue = form.getFieldValue('plantId');
        const hasPlantValue = apiBody.plantId || plantFieldValue;

        if (hasPlantValue && executionMaster.prefill_plant_with_destination_or_origin_address !== undefined) {
          showPlantConfirmationModal(plantFieldValue, apiBody);
          return;
        }
        // Directly submit if no plant value or config is undefined
        handleSubmit(apiBody);
      }
    });
  }

  const handleSubmit = async(apiBody) => {
    setCreating(true);
    let response: any;
    try {
      if (apiBody.id && !disableBooking) {
        response = await editShipment({
          ...apiBody,
          shipmentId: apiBody.id,
        });
      } else {
        response = await createShipment(apiBody);
      }
      if (response?.isSuccess) {
        message.success(`Shipment ${(apiBody.id && !disableBooking) ? 'Edited' : 'Created'} Successfully`);
        handleClose(true);
      } else {
        message.error(response?.errorMessage);
      }
    } finally {
      setCreating(false);
      isSubmitInProgressRef.current = false;
    }
  }

  const handleAction = (action: ButtonAction) => {
    switch (action) {
      case ButtonAction.PREV:
      case ButtonAction.NEXT: return handlePageChange(action);
      case ButtonAction.SUBMIT: return checkForErrors(true);
    }
  }

  const isFieldDiabled = (disableKey, isRequired) => {
    const isDisabled = Boolean(editData?.id && disableKey && editData[disableKey]);
    return isDisabled && !isRequired;
  };

  const renderButton = (name: string, action: ButtonAction) => {
    return <Button
      type={action === ButtonAction.SUBMIT ? 'primary' : 'link'}
      onClick={() => handleAction(action)}
      style={{ marginRight: 16 }}
      loading={creating}
      className={action === ButtonAction.SUBMIT ? classes.newButton : ''}
    >
      {action === ButtonAction.PREV && <Icon type="left"/>}
      {name}
      {action === ButtonAction.NEXT && <Icon type="right"/>}
    </Button>;
  };

  const renderLeftButton = () => {
    switch (currentPage) {
      case CurrentPage.FIRST: return <div></div>;
      case CurrentPage.SECOND:
      case CurrentPage.THIRD: return renderButton(ButtonNames.PREV, ButtonAction.PREV);
    }
  };

  const renderRightButton = () => {
    switch (currentPage) {
      case CurrentPage.FIRST:
      case CurrentPage.SECOND: return renderButton(ButtonNames.NEXT, ButtonAction.NEXT);
      case CurrentPage.THIRD: return null;
    }
  };

  const renderFooter = () => {
    return <div className={classes.footer}>
      {renderLeftButton()}
      {renderRightButton()}
    </div>;
  };

  function onClose(success = false) {
    handleClose(false);
  }

  const renderHeader = () => {
    return <div className = {classes.header}>
      <Icon
        type="close"
        onClick={() => onClose()}
      />
      <div
        style={{
          width: '100%',
          justifyContent: 'space-between',
          padding: 0,
        }}
        className={classes.header}>
        <span
          style={{ marginLeft: 10 }}>
          {editData?.id && !disableBooking ? 'Edit' : 'Create'} Shipment
        </span>
        {renderButton(ButtonNames.SUBMIT, ButtonAction.SUBMIT)}
      </div>
    </div>;
  };

  // The prefill writes the shipment's CARRIER booking number into the `bookingNumber` form field
  // (new-shipment.helper.ts convertEditdata), which is the field this "Shipsy Booking ID" Select is
  // bound to — so the control ends up showing e.g. AUJB02 instead of BKAMVU0002. Rather than change
  // what the field holds (it is what gets POSTed), give the Select an option matching that value and
  // label it with the Shipsy booking reference, so the display is right while the payload is untouched.
  const renderLinkedBookingOption = () => {
    const isLinked = editData?.sourceObjectType === 'BOOKING' && editData?.bookingNumber && editData?.bookingReferenceNumber;
    if (!isLinked || editData.bookingNumber === editData.bookingReferenceNumber) {
      return null;
    }
    return <Select.Option
        key={`linked-${editData.bookingNumber}`} value={editData.bookingNumber} label={editData.bookingReferenceNumber}>
      {editData.bookingReferenceNumber}
      </Select.Option>;
  };

  const renderBookingOptions = () => {
    return bookingList?.map(item => <Select.Option
        key={item.id} value={item.id} label={item.bookingNumber}>
      {item.bookingNumber}  
      </Select.Option>);
  };

  // ISS-293251 — the linked booking is edited like any other field: the Select's own clear control
  // empties it, choosing another swaps it, and nothing is persisted until Submit. Only orgs with the
  // rollout flag can edit a booking that is already linked; for everyone else the field stays locked.
  const linkedBookingValue = editData?.sourceObjectType === 'BOOKING' ? editData?.bookingNumber : undefined;
  const canEditLinkedBooking = Boolean(enableBookingDetach) && Boolean(editData?.id) && !disableBooking;
  const canRewriteBooking = canEditLinkedBooking && Boolean(linkedBookingValue);

  const handleBookingFieldChange = (id: any) => {
    const applyChange = () => {
      if (canRewriteBooking) {
        setBookingLinkEdited(true);
      }
      setBookingId(id);
    };
    // Ask once, the first time the user touches a booking that is already linked.
    if (canRewriteBooking && !bookingLinkEdited) {
      Modal.confirm({
        title: 'Change the linked booking?',
        content:
          'Are you sure you want to change the booking linked to this shipment? The current booking is unlinked when you submit, and that cannot be undone.',
        okText: 'Change booking',
        cancelText: 'Cancel',
        onOk: applyChange,
        onCancel: () => form.setFieldsValue({ [ShipmentFormFields.BOOKINGNUMBER.key]: linkedBookingValue }),
      });
      return;
    }
    applyChange();
  };

  const renderBooking = () => {
    return <div className={classes.booking}>
      <div style={{ width: '12%' }}>
        Shipsy Booking ID
        <Tooltip title="If you select an existing Shipsy Booking ID, all the data is prefilled based on the booking">
          <Icon
            type="info-circle"
            theme="filled"
            style={{ marginLeft: 8 }}
          />
        </Tooltip>
      </div>
      <FormItem
        className={classes.formItem}
        style={{ marginBottom: 0 }}
        {...formItemLayout}
      >
        {/* Keep the Select and the detach control together so the icon stays next to the
            dropdown regardless of the form-item width / screen ratio. */}
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {getFieldDecorator(BOOKINGNUMBER.key, {
            initialValue: editData?.sourceObjectType === 'BOOKING' ?
              editData?.bookingReferenceNumber : undefined,
          })(<Select
            showSearch
            allowClear
            notFoundContent={fetching ? (
              <div style={{ padding: '25px' }}>
                <Spin />
              </div>
            ) : 'Not Found'}
            style={{ width: 200 }}
            onChange={handleBookingFieldChange}
            disabled={Boolean(editData?.bookingNumber) && !canEditLinkedBooking}
            onSearch={val => setQuery(val)}
            filterOption={true}
            optionFilterProp={'label'}
            placeholder="Search Booking"
          >
            {renderLinkedBookingOption()}
            {renderBookingOptions()}
          </Select>)}
        </div>
      </FormItem>
    </div>
  };

  const renderFilledCircle = (page: CurrentPage) => {
    const activePage = page === currentPage;
    if (activePage) {
      return <div
        className={classes.filledCircle}
      />;
    }
    return null;
  };

  const renderCircle = (page: CurrentPage) => {
    const activePage = page === currentPage;
    return <div
      className={classes.tabIcon}
      style={{
        border: activePage ? '2px solid #006EC3' : '1px solid #333333',
        backgroundColor: activePage ? '#006EC3' : '#FFF',
      }}
    >
      {renderFilledCircle(page)}
    </div>;
  };

  const complete = () => {
    return <Icon
      type="check-circle"
      theme="filled"
      className={classes.dot}
    />;
  };

  const inComplete = () => {
    return <Icon
      type="exclamation-circle"
      theme="filled"
      className={classes.inComplete}
    />;
  };

  const renderTabIcon = (page: CurrentPage) => {
    if (currentPage === page) {
      return renderCircle(page);
    }
    switch (page) {
      case CurrentPage.FIRST: {
        if (currentPage === CurrentPage.FIRST) {
          return renderCircle(page);
        }
        if (pageErrorMap[CurrentPage.FIRST]) {
          return inComplete();
        }
        return complete();
      }
      case CurrentPage.SECOND: {
        if (pageErrorMap[CurrentPage.SECOND]) {
          return inComplete();
        }
        if (state.visited.SECOND || currentPage === CurrentPage.THIRD) {
          return complete();
        }
        return renderCircle(page);
      }
      case CurrentPage.THIRD: {
        if (pageErrorMap[CurrentPage.THIRD]) {
          return inComplete();
        }
        if (state.visited.THIRD) {
          return complete();
        }
        return renderCircle(page);
      }
    }
  };

  const renderTabName = (page: CurrentPage) => {
    return <div
      className={classes.tabName}
    >
      {TabNames[page]}
    </div>;
  };

  const renderTabDescription = (page: CurrentPage) => {
    return <div
      className={classes.tabDescription}
    >
      {TabDescription[page]}
    </div>;
  };

  const renderTabDetails = (page: CurrentPage) => {
    const activePage = page === currentPage;
    return <div
      style={{
        color: activePage ? '#111111' : '#666666',
        fontWeight: activePage ?  'bold' : 'normal',
      }}
    >
      {renderTabName(page)}
      {renderTabDescription(page)}
    </div>;
  };

  const handleTabChange = (page) => {
    if (page === currentPage) {
      return;
    }
    updateFormData();
    setState({ currentPage: page });
  };

  const renderTab = (page: CurrentPage) => {
    const activePage = page === currentPage;
    return <div
      className={classes.tabSelector}
      onClick={() => handleTabChange(page)}
      style={{ borderBottom: activePage ? '2px solid #006EC3' : 'none' }}
    >
      {renderTabIcon(page)}
      {renderTabDetails(page)}
    </div>;
  };

  const renderPageSelector = () => {
    return <div
      className={classes.pageSelector}>
      {Object.keys(CurrentPage).map((page: CurrentPage) => renderTab(page))}
    </div>;
  };

  const showLoader = isConfigLoading || isPrefillLoading;
  const commonProps = {
    form,
    loading,
    productsList,
    containerList,
    customerDetails,
    stakeholderDetails,
    originAddressDetails,
    destinationAddressDetails,
    teamIds,
    setContainers,
    setProducts,
    setCustomerDetails,
    setStakeholderDetails,
    setOriginAddressDetails,
    setDestinationAddressDetails,
    executionMaster,
    editData: formContent,
    inquiryMaster: props.inquiryMaster,
    domesticVehicleTypeSizeList: props.domesticVehicleTypeSizeList,
    formFieldConfig,
    isBlNumberPresent,
    isFieldDiabled,
    isConfigLoading: showLoader,
    setCustomFieldsMap,
    showRoadinsteadOfDomestic,
    isParentOrg: props.isParentOrg,
    isChildOrg: props.isChildOrg,
    stakeholderAccountType
  };

  const renderStepThree = () => {
    // if (currentPage !== CurrentPage.THIRD) {
    //   return null;
    // }
    return <StepThree {...commonProps} hide={currentPage !== CurrentPage.THIRD}/>;
  };

  const renderStepTwo = () => {
    // if (currentPage !== CurrentPage.SECOND) {
    //   return null;
    // }
    return <StepTwo {...commonProps} hide={currentPage !== CurrentPage.SECOND}/>;
  };

  const renderStepOne = () => {
    // if (currentPage !== CurrentPage.FIRST) {
    //   return null;
    // }
    return <StepOne {...commonProps } disableGrossWeightCalculation={disableGrossWeightCalculation} hide={currentPage !== CurrentPage.FIRST}/>;
  };

  const showPlantConfirmationModal = async (plantFieldValue: any, apiBody: ShipmentApiBody) => {
    // Capture the plant display name for the modal
    let plantDisplayName = 'Not selected';
    
    // Try to get label from various sources
    if (plantFieldValue?.label) {
      plantDisplayName = plantFieldValue.label;
    } else if (formContent?.plantId?.label) {
      // Check formContent for label
      plantDisplayName = formContent.plantId.label;
    } else if (plantFieldValue?.key || formContent?.plantId?.key || apiBody.plantId) {
      // If we only have the ID, fetch the plant details to get the name
      const plantId = plantFieldValue?.key || formContent?.plantId?.key || apiBody.plantId;
      try {
        const isCustomer = stakeholderAccountType === StakeholderTypes.CUSTOMER;
        const shipperId = isCustomer ? form.getFieldValue('shipperId') : undefined;
        const response = await getAddress(plantId, shipperId);
        
        if (response?.isSuccess && response.data) {
          plantDisplayName = response.data.name;
        } else {
          plantDisplayName = plantId;
        }
      } catch (error) {
        // If fetch fails, just show the ID
        plantDisplayName = plantId;
      }
    } else if (typeof plantFieldValue === 'string' && plantFieldValue) {
      plantDisplayName = plantFieldValue;
    }
    
    setSelectedPlantDisplay(plantDisplayName);
    setPendingApiBody(apiBody);
    setShowPlantConfirmModal(true);
  };

  const handlePlantConfirmModalOk = () => {
    setShowPlantConfirmModal(false);
    setPendingApiBody(null);
    // Use fresh apiBody from current form so plantId is always included (avoids timing/race issues)
    const { apiBody: freshApiBody } = getApiBodyAndUpdate();
    if (freshApiBody) {
      handleSubmit(freshApiBody);
    } else {
      isSubmitInProgressRef.current = false;
    }
  };

  const handlePlantConfirmModalCancel = () => {
    setShowPlantConfirmModal(false);
    setPendingApiBody(null);
    isSubmitInProgressRef.current = false;
  };


  return (
    <Drawer
      visible
      width="85%"
      title={renderHeader()}
      onClose={() => onClose()}
      className={classes.main}
      closable={false}
    >
      <Form>
        {renderBooking()}
        {showLoader && (
          <div className={classes.configLoader}>
            <Spin />
          </div>
        )}
        {renderPageSelector()}
        <Form form={form}>
          {renderStepOne()}
          {renderStepTwo()}
          {renderStepThree()}
          {renderFooter()}
        </Form>
      </Form>
      <Modal
        visible={showPlantConfirmModal}
        title="Confirm Plant Selection"
        onOk={handlePlantConfirmModalOk}
        onCancel={handlePlantConfirmModalCancel}
        okText="Confirm"
        cancelText="Cancel"
      >
        <p>Are you sure you want to proceed with this plant?</p>
        <p>
          <strong>Plant:</strong> {selectedPlantDisplay || 'Not selected'}
        </p>
      </Modal>
    </Drawer>
  );
};

const mapStateToProps = ({ masterData, inquiryReducer }) => {
  const { userData, execution } = masterData;
  return {
    carriers: masterData.globalShippingLines,
    executionMaster: {...execution, organisationId: userData?.organisation_id},
    orgType: userData.type,
    isParentOrg: masterData.isParentOrg,
    isChildOrg: masterData.isChildOrg,
    inquiryMaster: inquiryReducer.masterData,
    domesticVehicleTypeSizeList: masterData.domesticVehicleTypeSizeList,
    disableGrossWeightCalculation: !!masterData?.modules?.se_disable_gross_weight_calculation,
    // ISS-293251: detach-booking is dark by default. `!!undefined` keeps it off for every org
    // until se_enable_booking_detach is set on that org's organisation_config.modules.
    enableBookingDetach: !!masterData?.modules?.se_enable_booking_detach,
    showRoadinsteadOfDomestic: !!masterData?.modules?.show_road_instead_of_domestic,
    stakeholderAccountType: masterData?.stakeholderAccountType,
  };
};

const options: HocOptions = {
  connectRedux: {
    useRedux: true,
    mapStateToProps,
  },
  connectForm: {
    useForm: true,
  },
  connectJss: {
    useJss: true,
    styleSheet: newShipmentStyles,
  },
  permissionOptions: {
    nonNegotiable: [
      OrgTypes.SHIPPER,
      SHIP_EXEC_SHIPPER,
      PermissionTypes.SHIPMENT_ADD_EDIT,
    ],
  },
  connectRouter: true,
  useInquiryMasterData: true,
};

const NewShipmentForm = GenericHoc(options)(NewShipment);
export default NewShipmentForm;
